(function () {
  const transitionDuration = "400ms";
  const transitionType = "ease-in-out";

  // Collapses an element by animating its height and opacity to zero.
  const slideUp = (element) => {
    if (!element) return;
    const height = element.getBoundingClientRect().height;

    element.style.height = `${height}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = "0";
    element.style.opacity = "0";

    const cleanup = () => {
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      element.removeEventListener("transitionend", cleanup);
    };

    element.addEventListener("transitionend", cleanup);
  };

  // Expands an element by animating its height from zero to full scroll height.
  const slideDown = (element) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = `${height}px`;
    element.style.opacity = "1";
  };

  // Sets explicit height on items that are open by default so CSS transitions work correctly.
  const setDefaultHeight = (toggles) => {
    if (!toggles || toggles.length === 0) return;

    toggles.forEach((item) => {
      if (item.getAttribute("data-default-opened") === "true") {
        const answer = item.querySelector(".collapsible-content-item__answer");
        answer.style.height = `${answer.scrollHeight}px`;
      }
    });
  };

  // Selector for all natively focusable elements.
  const FOCUSABLE =
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  // Enables or disables tab focus for all focusable elements inside the answer panel.
  const setAnswerFocusability = (item, isOpen) => {
    const answer = item.querySelector(".collapsible-content-item__answer");
    if (!answer) return;
    answer.querySelectorAll(FOCUSABLE).forEach((el) => {
      if (isOpen) {
        el.removeAttribute("tabindex");
      } else {
        el.setAttribute("tabindex", "-1");
      }
    });
  };

  // Initialises all collapsible items within a given section.
  const initCollapsibleContent = (section) => {
    if (
      !section ||
      !section.classList.contains("collapsible-content-section")
    ) {
      return;
    }

    const toggles = section.querySelectorAll(".collapsible-content-item");

    setDefaultHeight(toggles);

    toggles.forEach((item) => {
      setAnswerFocusability(item, item.classList.contains("active"));
    });

    // Closes all items except the one currently being opened.
    const closeOtherItems = (currentItem) => {
      toggles.forEach((item) => {
        if (item !== currentItem) {
          item.classList.remove("active");
          item.removeAttribute("data-default-opened");
          const answer = item.querySelector(
            ".collapsible-content-item__answer"
          );
          slideUp(answer);
          item.setAttribute("aria-expanded", "false");
          setAnswerFocusability(item, false);
        }
      });
    };

    // Toggles the clicked item open or closed. Ignores clicks on links inside the answer.
    const handleClick = (event) => {
      const item = event.currentTarget;

      const answer = item.querySelector(".collapsible-content-item__answer");
      if (!answer) return;

      if (event.target && event.target.closest("a")) return;

      // The card is the control, but its answer is content: a click on the copy
      // (or on anything the merchant put in it) must not fold the item back up.
      if (event.target?.closest(".collapsible-content-item__answer")) return;

      if (item.classList.contains("active")) {
        slideUp(answer);
        item.classList.remove("active");
        item.removeAttribute("data-default-opened");
        item.setAttribute("aria-expanded", "false");
        setAnswerFocusability(item, false);
      } else {
        closeOtherItems(item);
        item.classList.add("active");
        slideDown(answer);
        item.setAttribute("aria-expanded", "true");
        setAnswerFocusability(item, true);
      }
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", handleClick);

      toggle.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        const answer = toggle.querySelector(
          ".collapsible-content-item__answer"
        );
        if (answer && answer.contains(document.activeElement)) return;
        event.preventDefault();
        handleClick({ currentTarget: toggle });
      });
    });
  };

  initCollapsibleContent(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    if (!window.Shopify.designMode) {
      initCollapsibleContent(event.target);
    }
  });
})();
